"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCardConfig = exports.defaultHeaderCardConfig = exports.defaultSectionConfig = void 0;
var defaultSectionConfig = {};
exports.defaultSectionConfig = defaultSectionConfig;
var defaultHeaderCardConfig = {};
exports.defaultHeaderCardConfig = defaultHeaderCardConfig;
var defaultCardConfig = {
    titleConfig: {
        align: 'left',
        margin: {
            desktop: '0 0 10px',
            tablet: '0 0 10px',
            mobile: '0 0 10px'
        }
    },
    descriptionConfig: {
        align: 'left'
    }
};
exports.defaultCardConfig = defaultCardConfig;
//# sourceMappingURL=Danke.js.map